import { IBrandResponse } from '@boma/shared/entities';

export interface ICatalogueItem {
  id: string;
  name: string;
  description: string;
  barcode: string;
  productCode: string;
  sku: string;
  price: number;
  brand: IBrandResponse;
  images: ICatalogueItemImage[];
  category: ICatalogueItemCategory;
  properties: ICatalogueItemProperty[];
  countries: ICatalogueItemCountry[];
  global: boolean;
  allowOnline: boolean;
  reseller: boolean;
}

export interface ICatalogueItemCategory {
  id: string;
  name: string;
}

export interface ICatalogueItemCountry {
  id: string;
  name: string;
  currencyName: string;
  productCode: string;
  sku: string;
  isoCurrencySymbol: string;
  taxRate: number;
  minimumPrice: number;
  defaultPrice: number;
  locations: ICatalogueItemCountryLocation[];
}

export interface ICatalogueItemCountryLocation {
  id: string;
  stockLocationId: string;
  name: string;
  isHeadOffice: boolean;
  isCurrentlyBeingSold: boolean;
  price: number;
  cost: number;
  minimumEstimatedDaysToDeliver: number;
  maximumEstimatedDaysToDeliver: number;
  acceptCashOnDelivery: boolean;
  acceptBankTransfers: boolean;
  acceptElectronicPayments: boolean;
  minimumOrderQuantity: number;
  maximumOrderQuantity: number;
  externalSalesEnabled: boolean;
  internalSalesEnabled: boolean;
  posSalesEnabled: boolean;
  internalPurchasesEnabled: boolean;
  enforceStockChecks: boolean;
  confirmAllExternalOrders: boolean;
  internalNegativeStockSalesAllowed: boolean;
  externalNegativeStockSalesAllowed: boolean;
}

export interface ICatalogueItemImage {
  url: string;
  sizes: ICatalogueItemImageSize[];
}

export interface ICatalogueItemImageSize {
  url: string;
  height: number;
}

export interface ICatalogueItemProperty {
  key: string;
  value: string;
}

export interface IAddOrUpdateCatalogueItemLocation {
  locationId: string;
  price: number;
  acceptCashOnDelivery: boolean;
  acceptBankTransfers: boolean;
  minimumOrderQuantity: number;
  maximumOrderQuantity: number;
}

export interface IUpdateEntityProductCountryDetails {
  countryId: string;
  productId: string;
  minimum: number;
  productCode: string;
  sku: string;
  defaultPrice: number;
}
